export const launchingVideo = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_CHANGE_END: {
          actions: ['scrollTop', 'setBodyNonScrollable'],
          cond: 'isVideoOpened',
        },
      },
    },
  },
};
